import styled, { css, keyframes } from 'styled-components';
import { neutral, white } from '../../../style/colors';

// ============== Shared Constants & Mixins ==============
export const MOBILE_BREAKPOINT = '1024px';

export const popIn = keyframes`
  0% { transform: scale(0.8); opacity: 0; }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); opacity: 1; }
`;

export const baseButton = css`
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const flexCenter = css`
  display: flex;
  align-items: center;
`;

export const menuItem = css`
  ${baseButton}
  ${flexCenter}
  width: 100%;
  gap: 12px;
  padding: 12px 20px;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: ${neutral[600]};

  &:hover {
    background: ${neutral[50]};
    color: ${neutral[900]};
  }

  i {
    font-size: 18px;
    color: ${neutral[500]};
  }
`;

// ============== Header Layout ==============
export const HeaderContainer = styled.header`
  background: ${white};
  backdrop-filter: blur(10px);
  border-bottom: 1px solid ${neutral[200]};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const HeaderContent = styled.div`
  ${flexCenter}
  justify-content: space-between;
  padding: 0 40px;
  height: 70px;
  max-width: 1920px;
  margin: 0 auto;
  gap: 40px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 0 16px;
    gap: 12px;
    height: 60px;
  }
`;

export const LeftSection = styled.div`
  ${flexCenter}
  gap: 20px;
`;

export const HamburgerButton = styled.button`
  ${baseButton}
  align-items: center;
  justify-content: center;
  display: none;
  padding: 8px;
  color: ${neutral[700]};
  border-radius: 8px;

  &:hover {
    background: ${neutral[100]};
    color: ${neutral[900]};
  }

  i {
    font-size: 24px;
    display: block;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) { display: flex; }
`;
